import isUrl from 'is-url';
import qs from 'qs';

export function parsePath(path: string) {
  const url = new URL(path, 'http://localhost');

  // Normalize pathname to always end with a trailing slash
  let pathname = url.pathname;
  if (pathname.length && pathname[pathname.length - 1] !== '/') {
    pathname += '/';
  }

  const { hash, search } = url;
  return { hash, pathname, search };
}

export function stringifyQueryString(obj: object): string {
  const queryObj = Object.fromEntries(
    Object.entries(obj).filter(([, value]) => typeof value !== 'undefined' && value !== null)
  );
  return qs.stringify(queryObj, {
    arrayFormat: 'comma',
    commaRoundTrip: true,
    encodeValuesOnly: true
  });
}

export function deLocalizePath(path: string, locales: string[] | readonly string[]): string {
  if (!path) {
    return path;
  }

  const { hash, pathname, search } = parsePath(path);

  const localeRegex = new RegExp(`^/(${locales.join('|')})/`, 'i');
  const newPath = pathname.replace(localeRegex, '/');

  return `${newPath}${search}${hash}`;
}

export function isValidUrl(str: string, opt?: { allowedProtocols: string[] }): boolean {
  if (!isUrl(str)) {
    return false;
  }
  const allowedProtocols = opt?.allowedProtocols || ['http', 'https'];
  const [, protocol] = /^([A-Za-z]+):\/\//.exec(str) || [];
  return allowedProtocols.includes(protocol);
}
